export default __webpack_public_path__ + "static/media/notFound.284ee408.png";